import tw, { styled } from "twin.macro";
import { COLORS } from "../../lib/styles/styles";
import { Image } from "antd";
import "antd/dist/antd.css";

export const WeddingCardWrapper = styled.div`
	${tw`p-1.5 overflow-hidden hover:(rounded-lg shadow-lg)`}
	max-width: ${({ large }) => (large ? "360px" : "320px")}!important;
	max-height: ${({ large }) => (large ? "320px" : "320px")} !important;
	min-width: ${({ large }) => (large ? "320px" : "300px")} !important;
	min-height: ${({ large }) => (large ? "300px" : "300px")} !important;
	border-radius: "15px";
	position: "relative";
`;

export const WeddingAlbumWrapper = styled.div`
	${tw`rounded-lg overflow-hidden flex flex-col gap-2 relative hover:(cursor-pointer shadow-md)`}
	width: 220px;
	height: 320px;
`;

export const WeddingAlbumImage = styled(Image)`
	${tw`overflow-hidden rounded-lg `}
	position: "relative";
	height: 240px;
	background: ${COLORS.appGentleGray};
	background-blend-mode: multiply;
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
`;

export const WeddingCardImage = styled(Image)`
	${tw`overflow-hidden hover:(cursor-pointer)`}
	display: flex;
	gap: 10px;
	justify-content: center;
	align-items: center;
	max-width: ${({ large }) => (large ? "320px" : "320px")}!important;
	max-height: ${({ large }) => (large ? "240px" : "200px")} !important;
	min-width: ${({ large }) => (large ? "300px" : "300px")} !important;
	min-height: ${({ large }) => (large ? "200px" : "200px")} !important;
	width: 100%;
	height: 100%;
	position: "relative";
	background-color: ${COLORS.appGentleGray};
	background-blend-mode: multiply;
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
`;

export const WeddingCardDetail = styled.div`
	${tw`overflow-hidden`}
	display: flex;
	flex-direction: row;
	gap: 10px;
	width: 100%;
	height: 80px !important;
`;

export const WeddingDate = styled.div`
	${tw`bg-appLightPink! rounded-xl`}
	width: 100px !important;
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
`;

export const WeddingCardContainer = styled.div``;
